import {
  ReferralInvite,
  ReferralInviteEvent,
} from '@interfaces/referralInvite';
import { fetcher } from '@utils/fetcher';

const API_URL = '/api/referralInvite';

export const findReferralInvite = async (): Promise<ReferralInvite> =>
  fetcher(API_URL, { method: 'GET' });

export const recordReferralInviteEvent = async (
  event: ReferralInviteEvent,
): Promise<void> =>
  fetcher(`${API_URL}/events`, { method: 'POST', body: { event } });

export const recordReferralLinkOpened = async (
  referrerCode: string,
): Promise<void> =>
  fetcher(`${API_URL}/linkOpened`, {
    method: 'POST',
    body: { referrerCode },
    // Entregue mesmo se a página fechar antes da resposta.
    keepalive: true,
  });
